import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const NavigationTab = ({ children, icon, title, link }) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);

  const toggleTab = () => {
    if (!open) history.push(link);
    setOpen(!open);
  };
  return (
    <li className="dash-nav__item">
      <div className="dash-nav__link" aria-hidden="true" onClick={toggleTab}>
        <span className="dash-nav__ico">
          <i className={icon} aria-hidden="true" />
        </span>
        <span className="dash-nav__text">{title}</span>
        <span className="dash-nav__arrow">
          <i className="fa fa-long-arrow-right" />
        </span>
      </div>
      <ul className="sub-nav" style={{ paddingLeft: 40 }}>
        {open && children}
      </ul>
    </li>
  );
};

export default NavigationTab;
